import { MessageCircle, Send } from "lucide-react";
import { COMPANY } from "@/data/services";

export default function FinalContact() {
  const msg = encodeURIComponent(
    `Hola, he realizado una estimación con la calculadora de ${COMPANY.name} y quiero que reviséis si el precio es realista. Os envío fotos del trabajo por aquí.`
  );
  return (
    <section className="bg-white scroll-mt-20">
      <div className="container mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="rounded-2xl border border-slate-200 bg-gradient-to-br from-[#E6F0FA]/60 to-white p-6 md:p-10 grid grid-cols-1 md:grid-cols-12 gap-6 items-center">
          <div className="md:col-span-8">
            <div className="text-[11px] uppercase tracking-[0.2em] text-[#004B87] font-semibold mb-3">Revisión gratuita</div>
            <h2 className="font-display font-semibold text-2xl md:text-3xl text-slate-900 tracking-tight">
              ¿Quieres saber si tu estimación es realista?
            </h2>
            <p className="text-slate-600 mt-3 text-sm md:text-base leading-relaxed max-w-2xl">
              Envíanos tu cálculo y fotos por WhatsApp. Revisaremos tu caso y te indicaremos si el precio puede mantenerse, si falta alguna partida o si conviene hacer una visita técnica.
            </p>
          </div>
          <div className="md:col-span-4">
            <a
              href={`https://wa.me/${COMPANY.whatsappIntl}?text=${msg}`}
              target="_blank" rel="noreferrer"
              data-testid="final-send-estimation-btn"
              className="inline-flex w-full items-center justify-center gap-3 h-14 px-6 rounded-xl bg-[#004B87] hover:bg-[#003A6A] text-white font-display font-semibold text-base transition-colors shadow-lg"
            >
              <Send className="w-5 h-5" />
              Enviar estimación por WhatsApp
            </a>
            <a
              href={`tel:+34${COMPANY.whatsapp}`}
              className="mt-3 inline-flex w-full items-center justify-center gap-2 h-11 text-slate-600 hover:text-[#004B87] font-medium text-sm transition-colors"
            >
              <MessageCircle className="w-4 h-4" />
              o llámanos al {COMPANY.whatsappFormatted}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
